






import Vue from 'vue';
import * as firebase from "firebase";

export default Vue.extend({
  name: 'App',

  components: {
  },

  data: () => ({
  }),

  created(): void {
    if (!this.$store.getters.logged_in) {
      this.$store.dispatch('login')
        .then((result) => {
        })
        .catch((err) => {
          console.log(err);
          if (this.$route.name !== 'Index') {
            this.$router.push('/');
          }
        });
    }
  },

  mounted(): void {
    this.$nextTick(() => {
      if (this.$store.state.isSmp) {
        setTimeout(function() {
          window.scrollTo(0, 10);
        }, 1000);
      }
    })
  }
});
